module.exports = __webpack_public_path__ + "img/back-arrow.10f15e11.svg";